import React, { useState } from "react";
import "antd/dist/antd.css";
import { Col, Button } from "antd";
import styles from "./DashBoard.module.scss";
import textStyles from "../../components/DashBoard/BookingSummary/BookingSummary.module.scss";
import { FilterCalendarIcon, leftOutlinedIcon } from "../../assets/images";
import moreOutlined from "../../assets/icons/moreOutlined.svg";

type FilterDateProps = {
  getDateRange: () => string;
  showDrawer: () => void;
};

const DashBoardFilterButtonMobile: React.FC<FilterDateProps> = ({
  getDateRange,
  showDrawer,
}) => {
  return (
    <>
      <Col
        xs={{ span: 24, order: 3 }}
        md={{ span: 10, order: 2 }}
        className={`${styles.contentRight} ${styles.calanderCotainer}`}
      >
        <img
          className={styles.calendarIconStyle}
          src={FilterCalendarIcon}
          alt="calander-icon"
        />{" "}
        <span className={textStyles.normalText16}>{getDateRange()}</span>
      </Col>
      <Col
        xs={{ span: 24, order: 2 }}
        md={{ span: 5, order: 3 }}
        className={styles.contentRight}
      >
        <Button className={styles.filterButtonStyle} onClick={showDrawer}>
          <img
            className={styles.threeDotStyle}
            src={moreOutlined}
            alt="filter-three-dot"
          />{" "}
          <span
            className={`${textStyles.normalText14} ${styles.filterTestStyle}`}
          >
            Filters
          </span>
        </Button>
      </Col>
    </>
  );
};

export default DashBoardFilterButtonMobile;
